import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'displayDate'
})
export class DisplayDatePipe extends DatePipe implements PipeTransform {

  transform(value: any, format: string, timezone?: string, locale?: string): any {
    //console.log(format, timezone, locale);
    let timezoneVal = timezone ? timezone : new Date().getTimezoneOffset().toString();
    let localeVal = locale ? locale : 'en-US';
    return super.transform(value, format, timezoneVal, localeVal);
  }

}
